module.exports = __webpack_public_path__ + "static/008-1f9fca73718fc468ed67987c1afe88c8.jpg";